<script>
import useDefineProductivityRepresentations
  from '@/composables/financial_management/define_productivity_representations/useDefineProductivityRepresentations'
import GeneralTable from '@/components/GeneralComponents/GeneralTable.vue'
import GeneralModal from '@/components/GeneralComponents/GeneralModal.vue'
import GeneralButton from '@/components/GeneralComponents/GeneralButton.vue'
import MainTable
  from "@/components/Financial_management_and_productivity/DefineProductivityRepresentations/MainTable.vue";
import EnhancedFormulaEditor
  from "@/components/Financial_management_and_productivity/DefineProductivityRepresentations/EnhancedFormulaEditor.vue";

export default {
  components: {EnhancedFormulaEditor, MainTable, GeneralTable, GeneralModal, GeneralButton},
  mounted() {
    this.fetchData()
  },

  data() {
    return {
      ...useDefineProductivityRepresentations().data(),
    }
  },

  methods: {
    ...useDefineProductivityRepresentations().methods
  }
}
</script>

<template>
  <div class="p-3">
    <div class="row justify-content-between align-items-end">
      <div class="col-4 text-right">
        <label class="form-label fw-bold">تعریف نماگر</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.definition"
        />
      </div>

      <div class="col-4 text-right">
        <label class="form-label fw-bold">هدف نماگر</label>
        <input
            type="text"
            class="form-control"
            v-model="newItem.purpose"
        />
      </div>

      <div class="col-md-2">
        <GeneralButton @clicked="addItem"/>
      </div>
    </div>

    <hr class="my-3">

    <!-- Items Table -->
    <MainTable
        :headers="tableHeaders"
        :fields="tableFields"
        :items="items"
        :variables="profits"
        :openEditModalMethod="openEditModal"
        :openCompleteFormulaModalMethod="openCompleteFormulaModal"
        @remove="removeItem"
    />

    <!-- Edit Item Modal -->
    <GeneralModal
        v-show="editedItem"
        title="ویرایش"
        modal-id="modalId"
        @save="handleUpdate"
    >
      <template v-if="editedItem">
        <div class="row justify-content-center align-items-end">
          <div class="col-4 text-right">
            <label class="form-label fw-bold">تعریف نماگر</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.definition"
            />
          </div>

          <div class="col-4 text-right">
            <label class="form-label fw-bold">هدف نماگر</label>
            <input
                type="text"
                class="form-control"
                v-model="editedItem.purpose"
            />
          </div>
        </div>
      </template>
    </GeneralModal>

    <!-- Formula Modal -->
    <div class="modal fade" id="formulaModalId" tabindex="-1" v-if="showFormulaModal">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">تکمیل / بروزرسانی</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body" style="overflow-y: auto; max-height: 15vw">
            <EnhancedFormulaEditor :latex-value="editedFormulaItem.formula" :profits="profits"
                                   @update:latex-value="(value) => editedFormulaItem.formula = value"/>
          </div>
          <div class="modal-footer justify-content-center gap-2">
            <a type="button" class="c-btn-primary-light" data-bs-dismiss="modal">لغو</a>
            <button type="button" class="c-btn-primary" @click="saveFormulas">ثبت نهایی تغییرات</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
input[disabled] {
  background-color: #eee !important;
  cursor: not-allowed !important;
}

.modal-dialog {
  min-width: 50vw;
}
</style>
